//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

export default {
  props: ["banner"],

  methods: {
    bannerTapped() {
      if (!this.banner) {
        return;
      }

      let kind = this.banner.get("kind");

      switch (kind) {
        case 1:
          this.$router.push({
            name: "quiz",
            params: { id: this.banner.get("quiz").id }
          });
          break;
        case 2:
          this.$router.push({
            name: "topic",
            params: { id: this.banner.get("topic").id }
          });
          break;
        case 3:
          window.location = this.banner.get("url");
          break;
        default:
          break;
      }
    }
  },

  data() {
    return {
      domain: null
    };
  },

  computed: {
    backgroundImage: function() {
      if (this.banner && this.banner.get("image")) {
        return this.banner.get("image").url();
      } else {
        return "http://wx3.sinaimg.cn/large/86e78dafgy1fs8soh0ulfj21kw0e8ta3.jpg";
      }
    },

    ...mapGetters(["isPc"])
  },

  created() {}
};



// WEBPACK FOOTER //
// ./src/components/Market.vue